import { useState } from 'react';
export function useForm(schema, options) {
    var _a;
    const [values, setValues] = useState((_a = options === null || options === void 0 ? void 0 : options.defaultValues) !== null && _a !== void 0 ? _a : {});
    const [errors, setErrors] = useState({});
    const get = (name) => {
        if (name == null) {
            throw new Error('Undefined `name` prop found in component. Please, make sure every form component has a `name` field.');
        }
        return values[name];
    };
    const set = (value, name) => {
        if (name == null) {
            throw new Error('Undefined `name` prop found in component. Please, make sure every form component has a `name` field.');
        }
        setValues((state) => (Object.assign(Object.assign({}, state), { [name]: value })));
    };
    const getError = (name) => {
        if (name == null) {
            throw new Error('Undefined `name` prop found in component. Please, make sure every form component has a `name` field.');
        }
        return errors[name];
    };
    const reset = () => {
        var _a;
        setErrors({});
        setValues((_a = options === null || options === void 0 ? void 0 : options.defaultValues) !== null && _a !== void 0 ? _a : {});
    };
    const validateAll = () => {
        const validationResult = schema.safeParse(values);
        if (validationResult.success) {
            setErrors({});
            return {
                data: validationResult.data,
                errors: undefined,
            };
        }
        else {
            const errors = {};
            for (const issue of validationResult.error.issues) {
                const key = issue.path[0];
                if (key == null) {
                    continue;
                }
                const errorsArray = errors[key];
                if (errorsArray == null) {
                    errors[key] = [issue.message];
                }
                else {
                    errorsArray.push(issue.message);
                }
            }
            setErrors(errors);
            return {
                errors,
                data: undefined,
            };
        }
    };
    const validate = (name) => {
        if (name == null) {
            throw new Error('Undefined `name` prop found in component. Please, make sure every form component has a `name` field.');
        }
        const validationResult = schema.safeParse(values);
        if (validationResult.success) {
            setErrors((errors) => (Object.assign(Object.assign({}, errors), { [name]: undefined })));
        }
        else {
            const errorsArray = [];
            for (const issue of validationResult.error.issues) {
                const key = issue.path[0];
                if (key === name) {
                    errorsArray.push(issue.message);
                }
            }
            setErrors((errors) => (Object.assign(Object.assign({}, errors), { [name]: errorsArray.length === 0 ? undefined : errorsArray })));
        }
    };
    return { set, get, values, reset, errors, validateAll, getError, validate };
}
//# sourceMappingURL=use-form.js.map